export default {
  setData(key, data) {
    let _data = data
    if (typeof data !== 'string') {
      _data = JSON.stringify(data)
    }
    localStorage.setItem(key, _data)
  },
  getData(key) {
    let _data = localStorage.getItem(key)
    try{
      _data = JSON.parse(_data)
      return _data
    }catch (e) {
      return _data
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js